import { memo } from 'react';
import { useAuthorization } from '@hotjar/webapp/domains/authorization';
import { useDemoNotification } from '@hotjar/webapp/features/Core/hooks/useDemoNotification';
import { useActivationAlerts } from '@hotjar/webapp/features/Activation/Alerts/useActivationAlerts';
import { useSiteIdSynchronization } from '@hotjar/site';
import { useUpsellUrlParams } from '@hotjar/webapp/features/Billing/Upsell/hooks/useUpsellUrlParams';
import { useTrackRouteChange } from '@hotjar/webapp/hooks/useTrackRouteChange';
import { useIdentifyOnce } from '@hotjar/webapp/hooks/useIdentifyOnce';
import { useSubscriptionAlerts } from '@hotjar/subscription-management/src/features/in-app-alerts/useSubscriptionAlerts';
import { useUpgradeRequestEvents } from '@hotjar/upsell';
import { useUserLocaleSetting } from '@hotjar/user';

/**
 * We've extracted these hooks out of the App component since we don't
 * need any return values from these hooks, and moving them out of the App
 * component means that the App component won't re-render when internal
 * state from these hooks updates.
 */
const InternalGlobalRuntimeHooks = (): null => {
  // hooks only have visible effect with new navigation
  useSubscriptionAlerts();
  useDemoNotification();
  useActivationAlerts();
  useUpsellUrlParams();
  useUpgradeRequestEvents();

  useSiteIdSynchronization();
  useAuthorization();
  useIdentifyOnce();
  useUserLocaleSetting();

  // Track all route changes and send Page Viewed events to Segment
  useTrackRouteChange();

  return null;
};

export const GlobalRuntimeHooks = memo(InternalGlobalRuntimeHooks);
